import React from "react";
import "./Info.css";

function Info() {
  return (
    <div className="info-container">
      <div className="info">
        <h1>"Un hogar fuera de casa: ¡Bienvenidos a Wine & Sun!"</h1>
      </div>
    </div>
  );
}

export default Info;
